<template>
    <div>
        <b-card v-for="cardDetails in CardList" :key="cardDetails.section" v-if="cardDetails.hasPermission">

            <b-card-header :class="{ 'collapsed': cardDetails.collapse }" v-b-toggle="cardDetails.section"
                :aria-expanded="cardDetails.collapse ? 'true' : 'false'" :aria-controls="cardDetails.section" role="tab"
                data-toggle="collapse">
                {{cardDetails.name}}
                <feather-icon icon="ChevronDownIcon" v-if="!cardDetails.collapse" />
                <feather-icon icon="ChevronUpIcon" v-else />

            </b-card-header>

            <b-collapse v-model="cardDetails.collapse" :visible="cardDetails.visible" :id="cardDetails.section" class="card-content">
            <b-card-body>
                <CustomFields :ModuleReference="cardDetails.section"/>
            </b-card-body>
            </b-collapse>
        </b-card>

    </div>
</template>


<script>
import {
    BRow,
    BCol,
    BCollapse,
    BCard,
    BCardHeader,
    BCardBody,
    VBToggle
} from "bootstrap-vue";
import CustomFields from "@/views/component/CustomFields.vue";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";
import { PermissionList } from "@/libs/defaultList";
export default {
    components: {
        BRow,
        BCol,
        BCollapse,
        BCard,
        BCardHeader,
        BCardBody,
        CustomFields
    },
    directives: {
        'b-toggle': VBToggle
    },
    data() {
        return {
            CardList: [{
                collapse: true,
                visible: true,
                section: "Product",
                name: 'Product',
                hasPermission: HasPermission(PermissionList.Inventory_View),
                customFields: []
            },
            {
                collapse: false,
                visible: true,
                section: "LeadClient",
                name: 'Lead/Customer',
                hasPermission: HasPermission(PermissionList.Sales_View),
                customFields: []
            },
            // {
            //     collapse: false,
            //     visible: true,
            //     section: "JobCard",
            //     name: 'JobCard',
            //     hasPermission: HasPermission(PermissionList.Production_View),
            //     customFields: []
            // },
            {
                collapse: false,
                visible: true,
                section: "Supplier",
                name: 'Supplier',
                hasPermission: HasPermission(PermissionList.Inventory_View),
                customFields: []
            },
            {
                collapse: false,
                visible: true,
                section: "RawMaterial",
                name: 'Raw Material',
                hasPermission: HasPermission(PermissionList.Inventory_View),
                customFields: []
            },
            {
                collapse: false,
                visible: true,
                section: "Employee",
                name: 'Employee',
                hasPermission: HasPermission(PermissionList.HRMS_View),
                customFields: []
            },
            {
                collapse: false,
                visible: true,
                section: "Vehicle",
                name: 'Vehicle',
                hasPermission: HasPermission(PermissionList.Distribution_View),
                customFields: []
            },
            {
                collapse: false,
                visible: true,
                section: "Delivery",
                name: 'Delivery',
                hasPermission: HasPermission(PermissionList.Distribution_View),
                customFields: []
            },
            {
                collapse: false,
                visible: true,
                section: "Equipment",
                name: 'Equipment',
                hasPermission: HasPermission(PermissionList.Equipment_View),
                customFields: []
            }
        ]
        }
    },
    async mounted() { },
    methods: { },
    computed:{ },
    setup(){
        return{
            HasPermission,
            PermissionList
        }
    }
}

</script>